// extracted by mini-css-extract-plugin
export var bold = "c9_jq";
export var container = "c9_f";
export var endQuote = "c9_jp";
export var linkArrowContainer = "c9_jm";
export var quoteContainer = "c9_jn";